
import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import { isLoggedIn } from "../../util/common.js";
import { toast } from "react-toastify";
const Index = () => {
  const navigate = useNavigate();
  const logged = isLoggedIn();
  const [formData, setFormData] = useState({ search: "" });
  const [statusFilter, setStatusFilter] = useState("");
  const [lspList, setLspList] = useState([]);
  const [filteredLspList, setFilteredLspList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [textValues, setTextValues] = useState({});
  const [addForm, setAddForm] = useState({
    name: "",
    userName: "",
    password: "",
    emailId: "",
    phoneNumber: "",
    isActive: false,
    webhookUrl: "",
  });
const [errors, setErrors] = useState({});

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [selectedLsp, setSelectedLsp] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [expandedRow, setExpandedRow] = useState(null);
  const [lspProducts, setLspProducts] = useState({});
  const [expandedProductVersions, setExpandedProductVersions] = useState({});
  const [productPolicies, setProductPolicies] = useState({});

   const [stateList, setStateList] = useState([]);  
  const [expandedVersionDetails, setExpandedVersionDetails] = useState({});
const [editFormData, setEditFormData] = useState(null);
const [editingVersionKey, setEditingVersionKey] = useState(null);
 



const handlePolicyUpdate = async (lsp, product, version) => {
  const payload = {
    lsp,
    product,
    version,
    details: {
      ...editFormData,
      version,
    },
  };
  try {
    await axiosInstance.post(URL.PRICING_UPDATE, payload);

    toast.success("Policy updated successfully.");
    setEditingVersionKey(null);
    handleProductClick(lsp, product); // to refresh updated data
  } catch {
    toast.error("Failed to update policy.");
  }
};
const renderScoreRanges = (data, label, valueKey) => {
  return (
    <div>
      <strong>{label}</strong>
      <ul className="mb-2">
        {data?.map((item, index) => (
          <li key={index}>
            Score {item.min_score}–{item.max_score}: {item[valueKey]}
          </li>
        ))}
      </ul>
    </div>
  );
};
  useEffect(() => {
    if (!logged) navigate("/auth/login");
    else fetchLspList();
  }, [logged]);

  useEffect(() => {
    handleFilter();
  }, [formData.search, statusFilter, lspList]);

  const fetchLspList = async () => {
    try {
      const response = await axiosInstance.get(URL.LSP_LIST);
      const sorted = response.data.sort((a, b) => b.id - a.id);
      setLspList(sorted);
      setFilteredLspList(sorted);
    } catch {
      toast.error("Failed to fetch LSPs.");
    }
  };


 
  const handleChange = (e) => {
  const { name, type, checked, value } = e.target;
  setAddForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
  }));
};

  const handleFilter = () => {
    let filtered = [...lspList];
    if (formData.search) {
      filtered = filtered.filter((lsp) =>
        lsp.name?.toLowerCase().includes(formData.search.toLowerCase())
      );
    }
    if (statusFilter) {
      filtered = filtered.filter((lsp) =>
        statusFilter === "active" ? lsp.isActive : !lsp.isActive
      );
    }
    setFilteredLspList(filtered);
  };

 

  const toggleModal = () => setShowModal((prev) => !prev);
  const togglePasswordModal = () => setShowPasswordModal((prev) => !prev);
const nameRegex = /^[A-Za-z ]{2,50}$/;
const handleAddInputChange = (e) => {
  const { name, value } = e.target;

  if (name === "name") {
    if (!nameRegex.test(value) && value !== "") {
      setErrors(prev => ({ ...prev, name: "Name must be 2-50 characters long and contain only letters and spaces." }));
    } else {
      setErrors(prev => ({ ...prev, name: "" }));
    }
  }
  setAddForm(prev => ({
    ...prev,
    [name]: value,
  }));
};
const handleAddSubmit = async () => {
  try {
    const response = await axiosInstance.post(URL.LSP_LIST_ADD, addForm);


     if (response.data?.error) {
      const errorMessage = response.data.error.includes(":")
        ? response.data.error.split(":").pop().trim()
        : response.data.error;
      toast.error(errorMessage);
      return;
    }
   toast.success("LSP added successfully");
    toggleModal();
    setErrors({});
  } catch (err) {
    const backendError = err.response?.data?.error;
    if (backendError) {
      const errorMessage = backendError.includes(":")
        ? backendError.split(":").pop().trim()
        : backendError;
      toast.error(errorMessage);
    } else {
      toast.error("Failed to add LSP.");
    }
  }

};
   
 

  const openPasswordModal = (lsp) => {
    setSelectedLsp(lsp);
    setNewPassword("");
    togglePasswordModal();
  };
  const handlePasswordUpdate = async () => {
    try {
      await axiosInstance.post(URL.LSP_LIST_PASSWORD_UPDATE, {
        id: selectedLsp.id,
        password: newPassword,
      });
      togglePasswordModal();
      toast.success("Password updated.");
    } catch {
      toast.error("Password must meet security requirements.");
    }
  };
  useEffect(() => {
  const fetchStates = async () => {
    try {
      const res = await axiosInstance.get(URL.LSP_STATE_LIST);
      setStateList(res.data);
    } catch (err) {
      console.error("Failed to load state list", err);
    }
  };

  fetchStates();
}, []);
  const updateStatus = async (id, isActive) => {
    if (!window.confirm(`Mark as ${isActive ? "Active" : "Inactive"}?`)) return;
    try {
      await axiosInstance.post(URL.LSP_UPDATE, { id, isActive });
      toast.success("Status updated.");
      setLspList((prev) =>
        prev.map((lsp) => (lsp.id === id ? { ...lsp, isActive } : lsp))
      );
    } catch {
      toast.error("Status update failed.");
    }
  };
  const handleRowClick = async (lspName) => {
    if (expandedRow === lspName) return setExpandedRow(null);
    try {
      const res = await axiosInstance.get(`${URL.PRICING_LIST}?lsp=${lspName}`);
      const products = res?.data?.products || [];
      setLspProducts((prev) => ({ ...prev, [lspName]: products }));
      setExpandedRow(lspName);
    } catch {
      toast.error("Failed to fetch LSP products.");
    }
  };
const validatePassword = (password) => {
  const missing = [];

  if (password.length < 8) missing.push("At least 8 characters");
  if (!/[a-z]/.test(password)) missing.push("One lowercase letter");
  if (!/[A-Z]/.test(password)) missing.push("One uppercase letter");
  if (!/\d/.test(password)) missing.push("One number");
  if (!/[@$!%*?&]/.test(password)) missing.push("One special character (@$!%*?&)");

  return missing;
};
  const handleProductClick = async (lspName, productName) => {
    const key = `${lspName}-${productName}`;
    const isExpanded = expandedProductVersions[key];
    setExpandedProductVersions((prev) => ({ ...prev, [key]: !isExpanded }));
    if (isExpanded) return;
    try {
      const res = await axiosInstance.get(`${URL.PRICING_LIST}?lsp=${lspName}&product=${productName}`);
      const policies = res?.data?.policies || [];
      setProductPolicies((prev) => ({ ...prev, [key]: policies }));
    } catch {
      toast.error("Failed to fetch policies.");
    }
  };
  const handleVersionClick = async (productKey, version) => {
    const key = `${productKey}-${version}`;
    const [lsp, product] = productKey.split("-");
    const isExpanded = expandedVersionDetails[key];
    setExpandedVersionDetails((prev) => ({ ...prev, [key]: !isExpanded }));
    if (isExpanded) return;
    try {
      const res = await axiosInstance.get(`${URL.PRICING_LIST}?lsp=${lsp}&product=${product}&version=${version}`);
      const details = res?.data?.details;
      if (!details) return toast.error("No version details found.");
      setProductPolicies((prev) => {
        const updated = [...(prev[productKey] || [])];
        const index = updated.findIndex(p => p.version === version);
        if (index !== -1) updated[index] = { ...details, version };
        else updated.push({ ...details, version });
        return { ...prev, [productKey]: updated };
      });
    } catch {
      toast.error("Version details fetch failed.");
    }
  };
const renderSplitColumns = (
  policy,
  onEditClick,
  editingVersionKey,
  setEditingVersionKey,
  editFormData,
  setEditFormData,
  lsp,
  product,
  handlePolicyUpdate
) => {
  const versionKey = `${lsp}-${product}-${policy.version}`;
  const isEditing = editingVersionKey === versionKey;

  const fields = ["rate_of_interest", "processing_fee", "foir", "tenure_days"];
  const labels = ["Interest Rate", "Processing Fee", "FOIR", "Tenure (Days)"];
  const keyMap = {
    rate_of_interest: "rate",
    processing_fee: "fee",
    foir: "foir",
    tenure_days: "tenure",
  };
  const textareaStyle = {
    width: "100%",
    minHeight: "120px",
    fontFamily: "monospace",
    fontSize: "0.9rem",
    padding: "8px",
    borderRadius: "4px",
    border: "none",
    background: "#f9f9f9",
    resize: "vertical",
    boxSizing: "border-box",
  };
  // Convert structured data to textarea format
  const toTextareaFormat = (field) => {
    const key = keyMap[field];
    const entries = editFormData[field] || [];
    return entries
      .map((e) => `Score ${e.min_score}–${e.max_score}: ${e[key]}`)
      .join("\n");
  };

  // Parse textarea content into structured objects
  const fromTextareaFormat = (field, text) => {
    const key = keyMap[field];
    const lines = text.split("\n").map((line) => line.trim()).filter(Boolean);
    const result = [];
    for (let line of lines) {
      const match = line.match(/Score\s+(\d+)[–-](\d+):\s*(\d+)/);
      if (match) {
        result.push({
          min_score: parseInt(match[1]),
          max_score: parseInt(match[2]),
          [key]: parseInt(match[3]),
        });
      }
    }
    return result;
  };
  const handleTextareaChange = (field, value) => {
    const parsed = fromTextareaFormat(field, value);
    setEditFormData({ ...editFormData, [field]: parsed });
  };
  const handleAddRow = (field) => {
    const key = keyMap[field];
    const existingText = toTextareaFormat(field);
    const newLine = `Score 0–0: 0`;
    const newText = existingText ? `${existingText}\n${newLine}` : newLine;
    handleTextareaChange(field, newText);
  };
  return (
    <div style={{ padding: "16px", borderRadius: "8px", marginBottom: "24px" }}>
      <div className="mb-2">
        <strong>Bureau:</strong>{" "}
        {isEditing ? (
          <input
            type="number"
            value={editFormData.bureau_type}
            onChange={(e) =>
              setEditFormData({ ...editFormData, bureau_type: Number(e.target.value) })
            }
            style={{ width: "80px", marginRight: "16px", border: "1px solid #ccc", padding: "4px" }}
          />
        ) : (
          policy.bureau_type
        )}
        <strong>Cut-Off Min:</strong>{" "}
        {isEditing ? (
          <input
            type="number"
            value={editFormData.cut_off_min}
            onChange={(e) =>
              setEditFormData({ ...editFormData, cut_off_min: Number(e.target.value) })
            }
            style={{ width: "80px", border: "1px solid #ccc", padding: "4px" }}
          />
        ) : (
          policy.cut_off_min
        )}
      </div>

      {/* Header Labels */}
      <div className="d-flex font-weight-bold mb-2" style={{ gap: "1rem" }}>
        {labels.map((label, idx) => (
          <div key={idx} style={{ width: "25%" }}>{label}</div>
        ))}
      </div>
      {/* Main Content - Editable or Display */}
      <div className="d-flex" style={{ gap: "1rem" }}>
        {fields.map((field, idx) => {
          const key = keyMap[field];
          return (
            <div key={idx} style={{ width: "25%", position: "relative" }}>
              {isEditing ? (
                <>
                  <textarea
                    value={toTextareaFormat(field)}
                    onChange={(e) => handleTextareaChange(field, e.target.value)}
                    style={textareaStyle}
                  />
                  <div style={{ position: "absolute", bottom: "6px", right: "6px" }}>
                    <button
                      onClick={() => handleAddRow(field)}
                      style={{
                        fontSize: "0.75rem",
                        padding: "4px 8px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      + Add Score
                    </button>
                  </div>
                </>
              ) : (
                (policy[field] || []).map((e, i) => (
                  <div key={i}>
                    Score {e.min_score}–{e.max_score}: {e[key]}
                  </div>
                ))
              )}
            </div>
          );
        })}
      </div>
      {/* Action Buttons */}
      <div className="text-right mt-3">
        {isEditing ? (
          <>
            <button
              style={{ background: "#28a745", color: "#fff", border: "none", padding: "6px 12px", marginRight: "8px", borderRadius: "4px" }}
              onClick={() => handlePolicyUpdate(lsp, product, policy.version, editFormData)}
            >
              Save
            </button>
            <button
              style={{ background: "#6c757d", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "4px" }}
              onClick={() => setEditingVersionKey(null)}
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            style={{ background: "#007bff", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "4px" }}
            onClick={() => {
              setEditingVersionKey(versionKey);
              setEditFormData(JSON.parse(JSON.stringify(policy)));
            }}
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
};
  return (
    <>
      {/* Header */}
      <div className="header bg-gradient-info pb-6 pt-4 pt-md-7">
        <Container fluid>
          <Row>
            <Col><h1 className="text-white">Welcome, User</h1></Col>
            <Col className="text-right">
              <Button color="success" onClick={toggleModal}>Add LSP</Button>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Main Container */}
      <Container fluid className="mt--7">
        {/* Filters */}
        <Row className="mt-5">
          <Col>
            <Card className="shadow p-4">
              <Row>
                <Col md="4">
                  <Input name="search" value={formData.search} onChange={handleChange} placeholder="Search by Fintech Name" />
                </Col>
                <Col md="4">
                  <Input type="select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="">All Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Input>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        {/* LSP Table */}
        <Row className="mt-5">
          <Col><Card className="shadow">
            <CardHeader className="border-0">
              <Row className="align-items-center"><Col><h3 className="mb-0">LSP List</h3></Col></Row>
            </CardHeader>
            <Table responsive className="align-items-center table-flush">
              <thead className="thead-light">
                <tr>
                  <th>Fintech Name</th>
                  <th>User Name</th>
                  <th>Secret Key (Code)</th> {/* ✅ Added column */}
                  <th>Status</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredLspList.map((lsp) => (
                  <React.Fragment key={lsp.id}>
                    <tr onClick={() => handleRowClick(lsp.name)} style={{ cursor: "pointer" }}>
                      <td>{lsp.name}</td>
                      <td>{lsp.userName}</td>
                      <td>
    <code className="text-primary">{lsp.code || "Not Generated"}</code> {/* ✅ Show Secret Key */}
  </td>
                      <td>
                        <ButtonDropdown
                          isOpen={dropdownOpen === lsp.id}
                          toggle={() => setDropdownOpen(dropdownOpen === lsp.id ? null : lsp.id)}
                        >
                          <DropdownToggle caret size="sm" color={lsp.isActive ? "success" : "danger"}>
                            {lsp.isActive ? "Active" : "Inactive"}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => updateStatus(lsp.id, true)} disabled={lsp.isActive}>Active</DropdownItem>
                            <DropdownItem onClick={() => updateStatus(lsp.id, false)} disabled={!lsp.isActive}>Inactive</DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </td>
                      <td>{lsp.emailId || "-"}</td>
                      <td>{lsp.phoneNumber || "-"}</td>
                      <td>
                    <Button
                    size="sm"
                    color="info"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/admin/lsp-update?${lsp.id}`);
                    }}
                  >
                    <i className="fa fa-eye" /> View
                  </Button>

                      </td>
                    </tr>

                    

                      {
                      
                      expandedRow === lsp.name && (
                        <tr>
                          <td colSpan="6" className="p-0">
                            <Table className="table-bordered mb-0">
                              <thead><tr><th>Product</th>
                              <th>Details</th></tr></thead>
                              <tbody>
                                {lspProducts[lsp.name]?.map((product) => {
                                  const key = `${lsp.name}-${product}`;
                                  return (
                                    <React.Fragment key={key}>
                                      <tr onClick={() => handleProductClick(lsp.name, product)} style={{ cursor: "pointer" }}>
                                        <td><strong>▶ {product}</strong></td>
                                        <td>Click to expand versions</td>
                                      </tr>
                                      {expandedProductVersions[key] &&
                                        productPolicies[key]?.map((policy, idx) => {
                                          const versionKey = `${key}-${policy.version}`;
                                          return (
                                            <React.Fragment key={versionKey}>
                                                <tr onClick={() => handleVersionClick(key, policy.version)} style={{ cursor: "pointer" }}>
                                          <td colSpan="2">
                                            <strong>{expandedVersionDetails[versionKey] ? "▼" : "▶"} Version: {policy.version}</strong>
                                          </td>
                                         </tr>
                                 {expandedVersionDetails[versionKey] && (
                               <tr>
                       <td colSpan="2">
                        
                  {
                  renderSplitColumns(
                       policy,
                 () => {
                   setEditingVersionKey(versionKey);
                      setEditFormData(policy);
                                 },
                  editingVersionKey,
                         setEditingVersionKey,
                        editFormData,
                       setEditFormData,
                             lsp.name,
                           product,
                          handlePolicyUpdate
                       )}
               </td>
              </tr>
              )}
           </React.Fragment>
                                          );
           })}
          </React.Fragment>
        );
       })}
      </tbody>
  </Table>
         </td>
          </tr>
            )}
             </React.Fragment>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
  isOpen={showModal}
  toggle={toggleModal}
  centered
  size="xl"  
  className="modal-dialog-scrollable"
>
  <ModalHeader toggle={toggleModal}>Add LSP Details</ModalHeader>

  <ModalBody>
    <Form>

       <Row>
        
        <Col md={4}>
          <FormGroup>
            <Label>Name</Label>
            <Input type="text" name="name" value={addForm.name} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Username</Label>
            <Input type="text" name="userName" value={addForm.userName} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>

       
          <Col md={4}>
          <FormGroup>
            <Label>Password</Label>
            <Input type="password" name="password" value={addForm.password} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
 

        <Col md={4}>
          <FormGroup>
            <Label>Email ID</Label>
            <Input type="email" name="emailId" value={addForm.emailId} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
         <Col md={4}>
          <FormGroup>
            <Label>Grievance Officer Email</Label>
            <Input type="grievance officer email" name="grievanceOfficerEmail" value={addForm.grievanceOfficerEmail} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
         {/* <Col md={4}>
          <FormGroup>
            <Label>Brand Name </Label>
            <Input type="brand name" name="brand name" value={addForm.brandName} onChange={handleAddInputChange} />
          </FormGroup>
        </Col> */}
         <Col md={4}>
          <FormGroup>
            <Label>Gst Number</Label>
            <Input type="gst number " name="gstNumber" value={addForm.gstNumber} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>

 


        {/* <Row> */}
        <Col md={4}>
          <FormGroup>
            <Label>CIN Number</Label>
            <Input type="text" name="cinNumber" value={addForm.cinNumber} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Company PAN Number</Label>
            <Input type="text" name="companyPanNumber" value={addForm.companyPanNumber} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Company Address</Label>
            <Input type="text" name="companyAddress" value={addForm.companyAddress} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>

<Col md={4}>
  <FormGroup>
    <Label>State</Label>
    <Input
      type="select"
      name="state"
      value={addForm.state}
      onChange={handleAddInputChange}
    >
      <option value="">Select State</option>
      {stateList.map((stateName, index) => (
        <option key={index} value={stateName}>
          {stateName}
        </option>
      ))}
    </Input>
  </FormGroup>
</Col>
        <Col md={4}>
          <FormGroup>
            <Label>SPOC Name</Label>
            <Input type="text" name="spocName" value={addForm.spocName} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>SPOC Phone Number</Label>
            <Input type="text" name="spocPhoneNumber" value={addForm.spocPhoneNumber} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>SPOC Email</Label>
            <Input type="email" name="spocEmail" value={addForm.spocEmail} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Grievance Officer Name</Label>
            <Input type="text" name="grievanceOfficerName" value={addForm.grievanceOfficerName} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Grievance Officer Phone</Label>
            <Input type="text" name="grievanceOfficerPhone" value={addForm.grievanceOfficerPhone} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Phone Number</Label>
            <Input type="text" name="phoneNumber" value={addForm.phoneNumber} onChange={handleAddInputChange} />
          </FormGroup>
        </Col>
          {/* <Col md={4}>
          <FormGroup>
            <Label>Version</Label>
            <Input type="text" name="version" value={addForm.version} onChange={handleAddInputChange} />
          </FormGroup>
        </Col> */}

        {/* Insert this inside the <Row> within <ModalBody> */}
<Col md={4}>
  <FormGroup>
    <Label>Webhook URL (Optional)</Label>
    <Input 
      type="url" 
      name="webhookUrl" 
      placeholder="https://your-api.com/webhook"
      value={addForm.webhookUrl} 
      onChange={handleAddInputChange} 
    />
  </FormGroup>
</Col>

        <Col md={4}>
  <FormGroup>
    <Label>Bureau Type</Label>
    <Input
      type="select"
      name="bureauType"
      value={addForm.bureauType}
      onChange={handleAddInputChange}
    >
      <option value="">Select Bureau</option>
      <option value="1">CIBIL</option>
      <option value="2">Equifax</option>
      <option value="3">Experian</option>
      <option value="4">CRIF</option>
    </Input>
  </FormGroup>
</Col>

<Col md={4} className="d-flex align-items-center">
  <FormGroup check>
    <Label check>
      <Input
        type="checkbox"
        name="isActive"
        checked={addForm.isActive}
        onChange={handleChange}
      />{" "}
      Active
    </Label>
  </FormGroup>
</Col>
      
{/*  
                     <Col md={4} className="d-flex align-items-center">
                       <FormGroup check>
                         <Label check>
                           <Input
                             type="checkbox"
                             name="isActive"
                             checked={addForm.isActive}
                             onChange={handleChange}
                           />{" "}
                           Active
                         </Label>
                       </FormGroup>
                     </Col> */}

      </Row>
    </Form>
  </ModalBody>
  <ModalFooter>
    <Button color="primary" onClick={handleAddSubmit}>Save</Button>
    <Button color="secondary" onClick={toggleModal}>Cancel</Button>
  </ModalFooter>
</Modal>

      {/* Update Password */}
      <Modal isOpen={showPasswordModal} toggle={togglePasswordModal}>
        <ModalHeader toggle={togglePasswordModal}>Update Password</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>New Password</Label>
            <Input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="e.g. Salora@123" />
            <small className="text-muted">8–16 chars, 1 uppercase, 1 number, 1 special char.</small>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handlePasswordUpdate}>Update</Button>
          <Button color="secondary" onClick={togglePasswordModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default Index;
